import session from "../../../services/session";
import swal from "sweetalert2";
import AdminApi from "../../../services/api";
import CONFIG_COMPANY from "../../../services/myConfig";
import Loc from "../../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            sevenDay: '',
            date: null
        }
    },
    methods: {
        createSlots: createSlots
    },
    beforeMount() {
        if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.sevenDay = this.$moment(new Date()).add(7, 'days').format('DD-MM-YYYY')
    }


}

function createSlots() {
    let request = {
        date: this.date
    }
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {
    });

    AdminApiService.openSlots(request)
        .then((response) => {
            swal(LocService.t('label_success'), LocService.t('label_open_trainings_success'), 'success')
            this.date = null
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}



// WEBPACK FOOTER //
// ./src/components/Term/Open/OpenTerms.js